import { render, staticRenderFns } from "./abstract-transfer-protocol-modal.vue?vue&type=template&id=136f26b4&scoped=true"
import script from "./abstract-transfer-protocol-modal.vue?vue&type=script&lang=js"
export * from "./abstract-transfer-protocol-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136f26b4",
  null
  
)

export default component.exports